<template lang="pug">
.item(:style="{cursor: 'pointer', width: miAncho + 'px', margin: miMargen + 'px', 'background-image': 'url(src/modulos/galerias/php/api/thumb.php?ItemID=' + item.ItemID + ')'}", @click="selecciona")
	span.fa.fa-caret-right.playBtn(v-if="item.Tipo === 'Video'")
</template>

<script>
export default {
	props: ['item', 'ancho', 'margen'],
	data () {
		return {
			miMargen: 2,
			miAncho: 200
		}
	},
	created () {
		if (this.ancho) {
			this.miAncho = this.ancho
		}
		if (this.margen) {
			this.miMargen = this.margen
		}
	},
	methods: {
		selecciona () {
			this.$emit('selecciona', this.item)
		}
	}
}
</script>


<style scoped>
	.item {
		position: relative;
		display: inline-block;
		width: 200px;
		height: 200px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		margin: 5px;
	}
	.playBtn {
		position: absolute;
		display: block;
		font-size: 4em;
		top: 35%;
		text-align: center;
		left: 0;
		right: 0;
		color: white;
		text-shadow: 0 0 10px rgba(0,0,0,0.8);
	}
</style>



// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/visor-item/mini-item.vue